import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	isMmcAdmin: false,
	calInstCdList: [], //교정업체 selectBox
	calStCdList: [], //교정상태 selectBox
	runStCdList: [], //가동상태 selectBox
	calWayCdList: [], //교정방식 selectBox
	calCyclCdList: [], //교정주기 selectBox
	calRsltCdList: [], //교정결과 selectBox
	sndStCdList: [], //메일 발송상태 selectBox
	resultList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),

	pvoResultList: [],
	pvoPagingInfo: PAGING_INFO(),

	csetResultList: [],
	csetPagingInfo: PAGING_INFO(),

	pvoResultList: [],

	// 사용자 공통팝업 파라미터 정보
	searchUserPopParams: SEARCH_USER_POPUP_PARAMS()
};

function SEARCH_PARAMS() {
	return {
		mesEqipNo: '',
		mesEqipNm: '',
		calStCd: '', //교정상태
		runStCd: '', //가동상태
		calInstCd: '', //교정업체
		userId: '',
		userName: '',
		useDeptCd: '',
		useDeptNm: '',
		strDt: startDt,
		endDt: endDt
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

//사용자 조회 팝업
function SEARCH_USER_POPUP_PARAMS() {
	return {
		userName: '',
		userId: ''
	};
}
export { SEARCH_PARAMS, PAGING_INFO, SEARCH_USER_POPUP_PARAMS };
